import { render, staticRenderFns } from "./paNotifyManage.vue?vue&type=template&id=7cb59eee&"
import script from "./paNotifyManage.vue?vue&type=script&lang=js&"
export * from "./paNotifyManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports